import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { adminApi } from '@/lib/admin-api-client';

interface RequireAdminAuthProps {
  children: ReactNode;
}

export function RequireAdminAuth({ children }: RequireAdminAuthProps) {
  const token = adminApi.getToken();
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return <>{children}</>;
}
